export function getView(value) {
  return value ? 'Person' : 'Template'
}
